export const normalize = (value: string) =>
  (value || "").normalize("NFD")
    // remove marcas diacriticas (acentos) - faixa Unicode dos combining diacritical marks, ES5-safe
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const isAutoPericiaHRF = (name: string) =>
  normalize(name) === normalize("CHECKVIEW COMPLETA") || normalize(name) === normalize("CHECKVIEW COMPLETO") || normalize(name) === normalize("CHECKAUTO COMPLETA");
